<template>
  <div id="prodClassRepUpgradeModal" class="modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content first-modal-content">
        <div class="modal-header deactiveModal-bgcolor">
          <button type="button" class="close" data-toggle="modal" data-target="#prodClassRepUpgradeModal">&times;</button>
          <div class="modal-title">
            <div class="title-text">Are you sure you want to upgrade this classification rationale report?</div>
          </div>
        </div>
        <!-- <div class="modal-body desc-text">
          <p>Account has the following active premium services:</p>
        </div> -->
        <div class="modal-footer deactiveModal-bgcolor">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mr-tp-10">
            <button
              class="btn btn-block emergo-white-button"
              data-toggle="modal"
              data-target="#prodClassRepUpgradeModal"
            >No, Cancel</button>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mr-tp-10">
            <button
              class="btn btn-block emergo-blue-button"
              href="#ConfirmationModal"
              @click="upgradeProductClassificationRationale"
            >Yes, Upgrade</button>
          </div>
        </div>
        <loader :loadingStatus="loaderStatus"></loader>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import Loader from '../UIComponents/Loader.vue';
import { upgradeRationaleReport } from '../../apis/prodClassification';

export default {
  data() {
    return {
      loaderStatus: false,
    };
  },
  props: ['headerId'],
  components: {
    Loader,
  },
  methods: {
    async upgradeProductClassificationRationale() {
      this.loaderStatus = true;
      this.loaderStatus = false;
      const payload = {
        rationale_report_id: this.headerId,
      };
      const respData = await upgradeRationaleReport(payload);
      if (respData && respData.message === 'success') {
        this.$emit('upgraded', 1);
        this.$parent.getServices();
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Rationale report upgraded successfully',
          group: 'custom-notification',
        });
        $('#prodClassRepUpgradeModal').modal('hide');
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to upgrade rationale report!',
          group: 'custom-notification',
        });
      }
    },
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
  },
};
</script>

<style scoped>
.mr-tp-10{
  margin-top: 10px;
}
.modal-header .close {
  background: none;
  opacity: 0.5;
  height: 17px;
  line-height: 17px;
  color: #828282;
  width: 17px;
  border-radius: 20px;
  font-weight: 300;
  outline: none;
  font-size: 32px;
}
.modal-header{
    padding:0;
}
.modal-title{
    padding:15px;
}
.modal-header.deactiveModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.confirm-body {
  padding: 5% 12%;
  margin-bottom: 10%;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
}
.modal-footer.deactiveModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.modal-footer.deactiveModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.modal-content.first-modal-content {
  padding: 15px;
  border-radius: 12px;
}
.title-text {
  font-size: 18px;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
  padding-top: 10px;
}
.bold-text {
  font-size: 24px;
  line-height: 28px;
  font-weight: 500;
  text-align: center;
  color: #0b3c61;
  padding-top: 10px;
}
.desc-text {
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #828282;
  margin:auto;
  width:75%;
}
.modal-footer.deactiveModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
  padding-bottom: 32px;
}
.modal-header.scnd-deactiveModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
  padding-bottom: 0px;
}
div#deactiveModal {
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-header.upgradeModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.ul-items{
    text-align: left;
    color: #0b3c61;
    font-weight: normal;
    font-size: 14px;
}
@media screen and (max-width: 767px){
    .desc-text{
          text-align: center;
          width:100%;
    }
}
</style>
